import {
  VerticalRectangle01,
  VerticalRectangle02,
  VerticalRectangle03,
  VerticalRectangle04,
  VerticalRectangle05,
  VerticalRectangle06,
  VerticalRectangle07,
  VerticalRectangle08,
  VerticalRectangle09,
  VerticalRectangle10,
} from "./verticalRectangles";

export const DEFAULT_VERTICAL_RECTANGLE_WIDTH = 1080;

export default function VerticalRectangleShape({
  size,
  variantColor,
  shape,
  imageUrl,
  logoSrc = "",
  primaryText,
  secondaryText,
  callText,
  positions,
  x_axis = 50,
}) {
  switch (shape) {
    case 1:
    default:
      return (
        <VerticalRectangle01
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 2:
      return (
        <VerticalRectangle02
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 3:
      return (
        <VerticalRectangle03
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 4:
      return (
        <VerticalRectangle04
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 5:
      return (
        <VerticalRectangle05
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 6:
      return (
        <VerticalRectangle06
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 7:
      return (
        <VerticalRectangle07
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 8:
      return (
        <VerticalRectangle08
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 9:
      return (
        <VerticalRectangle09
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );

    case 10:
      return (
        <VerticalRectangle10
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
  }
}
